import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class MapListSliderService {

  private checked = new BehaviorSubject(false);
  checkedServiceVal = this.checked.asObservable();

  private disabled = new BehaviorSubject(false);
  disabledServiceVal = this.disabled.asObservable();

  private send = new BehaviorSubject('list');
  sendServiceVal = this.send.asObservable();

  constructor() { }

  checkedSlider(checkedParam: boolean) {
    this.checked.next(checkedParam)
  }

  disabledSlider(disabledParam: boolean) {
    this.disabled.next(disabledParam)
  }

  sendSlider(sendParam: string) {
    this.send.next(sendParam)
  }

}